export default () => ({
    currentTab: 'grid',
    
    selectTab(tab) {
        this.currentTab = tab;
    },

    isSelected(tab) {
        return this.currentTab === tab;
    }
});
